let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fIPlf")).then(() => parcelRequire('lyW48'));